<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>

<script>
// JavaScript 区域
export default {
  data() {
    return {
      // message: 'Hello App',
    };
  },


  mounted() {
    // console.log('App.vue mounted');
    if (localStorage.getItem('darkTableText')) {
      document.body.classList.add('dark-table-text');
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 只改变 el-table 单元格文字颜色，排除按钮/标签 */
/* .el-table .el-table__body td, */

/* .el-table .el-table__body .cell.el-tooltip {
  color: #333333;
} */
/* .el-table.dark-text .el-table__body .cell.el-tooltip {
  color: #333333;
} */

body.dark-table-text .el-table .el-table__body .cell.el-tooltip {
  color: #333
}
body.dark-table-text .el-table .el-table__header .cell{
  color: #777
}
 
/* ::-webkit-scrollbar {
  width: 8px; 
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 10px; 
}

::-webkit-scrollbar-thumb:hover {
  background: #555; 
} */
/* WebKit 浏览器 (Chrome, Safari) */
::-webkit-scrollbar {
  width: 5px;
  /* 滚动条的宽度 */
  height: 5px;
  /* 横向滚动条的高度 */
  transition: all 0.3s ease-in-out;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 滚动条轨道背景 */
  border-radius: 10px;
  /* 滚动条轨道的圆角 */
}

::-webkit-scrollbar-thumb {
  background-color: #aaa;
  /* 滚动条的颜色 */
  border-radius: 10px;
  /* 滚动条圆角 */
  border: 1px solid transparent;
  /* 防止背景覆盖轨道 */
  background-clip: content-box;
  /* 内容剪辑方式 */

}

::-webkit-scrollbar-thumb:hover {
  background-color: #888;

}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;

}

.el-table__body-wrapper:hover::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::v-deep .right-input input {
  text-align: right;
}


/* Firefox 浏览器
* {
  scrollbar-width: thin; 
  scrollbar-color: #888 #f1f1f1; 
} */


/* nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */



.table-search {
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 10px;
  border: 1px solid #dcdfe6;
  filter: drop-shadow(0px 0px 6px rgba(88, 88, 88, 0.15));
  top: 5px;
  right: 8px;
  z-index: 999;
  transition: all 0.3s;
}

.table-search:hover {
  width: 250px;
  /* height: 30px;
    right: 5px; */
  opacity: 1;
}

.table-search .el-input {
  width: 0;
  height: 26px;
  display: none;
  transition: all 0.3s;
}

.table-search:hover .el-input {
  width: 205px;
  height: 26px;
  display: inline-table;
  transition: all 0.3s;
}

.table-search i {
  right: 0px;
  font-size: 16px;
  color: #66b1ff;
  margin: 0 8px;
  transition: all 0.3s;
}

.table-search:hover i {
  right: 0px;
  font-size: 16px;
  color: #66b1ff;
  margin: 0 8px;
  transform: rotateY(360deg);
}

/* .table-search i{
    animation: table-search-i 2s infinite linear;
}
@keyframes table-search-i {
    0%,80% {
        transform: rotateY(0deg);
    }
    100% {
        transform: rotateY(360deg);
    }
    
} */



/* popover弹出层的自定义样式 */
.popover-container {
  /* background-color: #888 !important; */
  /* border: 1px solid #353535 !important; */
  border-radius: 10px !important;
  /* box-shadow: 0px 0px 6px rgba(88, 88, 88, 0.15) !important; */
  filter: drop-shadow(0px 0px 6px rgba(88, 88, 88, 0.3333)) !important;
}

/* 用于定义echart tooltip的样式  主要修改z-index   */
/* .custom-echart-tooltip{
  z-index: 999 !important;
} */
</style>
